import {
  External_Authentication_Type,
  useSettings_ExternalAuth_Azure_UpdateMutation,
  useSettings_ExternalAuth_Ldap_UpdateMutation,
  useSettings_ExternalAuth_SetStateMutation,
  useSettings_ExternalAuthsQuery,
} from '@/graphql/codegen/generated/graphql';
import { computed, provide } from 'vue';
import { IKActiveDirectory } from '@/components/common/dialogs/settingsActiveDirectoryDialog/activeDirectory.injection.keys';

export const useActiveDirectoryProvider = () => {
  const GQL_MUTATION_Deactivate_Active_Directory = useSettings_ExternalAuth_SetStateMutation({});
  const GQL_MUTATION_Activate_ldap = useSettings_ExternalAuth_Ldap_UpdateMutation({});
  const GQL_MUTATION_Activate_azureAD = useSettings_ExternalAuth_Azure_UpdateMutation({});
  const GQL_get_Active_Directory = useSettings_ExternalAuthsQuery();

  const ldapAuthData = computed(() => GQL_get_Active_Directory?.result?.value?.settings_externalAuths?.ldapAuth);
  const azureAuthData = computed(() => GQL_get_Active_Directory?.result?.value?.settings_externalAuths?.azureADAuth);
  const activateAD = async (authenticationType: External_Authentication_Type, form: any) => {
    const payload = {
      enabled: true,
      ...form,
    };
    if (authenticationType === External_Authentication_Type.Ldap) {
      return GQL_MUTATION_Activate_ldap.mutate({
        input: payload,
      });
    }
    if (authenticationType === External_Authentication_Type.AzureAd) {
      return GQL_MUTATION_Activate_azureAD.mutate({
        input: payload,
      });
    }
    return null;
  };

  const deactivateActiveDirectory = async (authenticationType: External_Authentication_Type) => {
    const payload = {
      enabled: false,
      authenticationType,
    };
    return GQL_MUTATION_Deactivate_Active_Directory.mutate({
      input: payload,
    });
  };

  const payload = {
    GQL_GetAD_Data: GQL_get_Active_Directory,
    deactivateActiveDirectory,
    activateAD,
    GQL_activateLdap: GQL_MUTATION_Activate_ldap,
    GQL_activateAzure: GQL_MUTATION_Activate_azureAD,
    ldapAuthData,
    azureAuthData,
  };

  provide(IKActiveDirectory, payload);
  return payload;
};
